import { useQuery } from "react-query";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import { uuidv4 } from "../../../../../utils";

const getGroupHousingData = (id = null) => {
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [, applicationFlow] = useDepartmentSelector();
  const { info: userInfo } = Digit.UserService.getUser();
  console.log("insideGetEdcrData", id);

  if (id) {
    const fetchApplicationData = async () => {
      return await Digit.OBPSService.BPASearch(tenantId, { applicationId: id, isEmployee: false });
    };

    const { data, isLoading: isAppDataLoading, isSuccess } = useQuery({ queryKey: [id], queryFn: fetchApplicationData });
    const edcrData = isSuccess && data?.BPA?.[0];
    console.log("edcrDataFromGetGrouphousing", edcrData);

    const applicationData = {
      // Application Info
      applicationNumber: edcrData?.applicationNo,
      applicationId: edcrData?.applicationId,
      appliactionType: "BUILDING_PLAN_SCRUTINY",
      applicationSubType: "NEW_CONSTRUCTION",
      transactionNumber: uuidv4(),
      isRevised: edcrData?.isRevised,
      drawingDetail: edcrData?.drawingDetail,
      // Location Details
      district: edcrData?.district,
      proposal: edcrData?.proposal,
      plotAreaDoc: edcrData?.plotAreaDoc,
      mapSubDetails: edcrData?.mapSubDetails,
      descriptionOfLand: edcrData?.descriptionOfLand,
      fastPASId: edcrData?.fastPASId,
      landMark: edcrData?.landMark,
      tehsil: edcrData?.tehsil,
      revenueVillage: edcrData?.revenueVillage,
      khasraNo: edcrData?.khasraNo,
      city: edcrData?.city,
      locality: edcrData?.locality,
      village: edcrData?.village,
      doorNo: edcrData?.doorNo,
      code: edcrData?.code,

      // Scheme/Layout Details
      schemeName: edcrData?.schemeName,
      sectorNo: edcrData?.sectorNo,
      plotNo: edcrData?.plotNo,
      plotNumbers: edcrData?.plotNumbers,
      plotArea: edcrData?.descriptionOfLand?.landArea,
      planOn: edcrData?.planOn,
      otherSchemeName: edcrData?.otherSchemeName,
      isApprovedLayout: edcrData?.isApprovedLayout,
      layoutsanctionNumber: edcrData?.layoutsanctionNumber,
      layoutsanctionDate: edcrData?.layoutsanctionDate,

      // Construction Details
      natureOfConstruction: edcrData?.natureOfConstruction,
      buildingClassification: edcrData?.buildingClassification,
      otherbuildingClass: edcrData?.otherbuildingClass,
      zoneType: edcrData?.zoneType,
      subZoneType: edcrData?.subZoneType,
      primaryUse: edcrData?.primaryUse,
      activityProposed: edcrData?.activityProposed,
      areaType: edcrData?.areaType,
      developmentArea: edcrData?.developmentArea,
      subDevelopmentArea: edcrData?.subDevelopmentArea,

      // Technical Parameters
      fars: edcrData?.fars,
      fars: edcrData?.far,
      groundCoverage: edcrData?.groundCoverage,
      groundCoverages: edcrData?.groundCoverage,
      buildingHeight: edcrData?.buildingHeight,
      setbackFronts: edcrData?.setbackFronts,
      setbackRears: edcrData?.setbackRears,
      backSide: edcrData?.backSide,
      isPlotSetback: edcrData?.isPlotSetback,

      // Special Project Details
      isSpecialProject: edcrData?.isSpecialProject,
      projectType: edcrData?.projectType,
      otherProjectName: edcrData?.otherProjectName,
      communityParking: edcrData?.communityParking,
      anyotherCondition: edcrData?.anyotherCondition,
      previousSetbackFront: edcrData?.previousSetbackFront,
      previousSetbackRear: edcrData?.previousSetbackRear,
      previousSetbackSide1: edcrData?.setbackSide1,
      previousSetbackSide2: edcrData?.setbackSide2,

      // Proposal Details
      proposalType: edcrData?.proposalType,
      noOfPlots: edcrData?.noOfPlots,
      sanctionNumber: edcrData?.sanctionNumber,
      sanctionDate: edcrData?.sanctionDate,
      prevFileNo: edcrData?.prevFileNo,
      landUseNo: edcrData?.applicationNo,
      purchasableFAR: edcrData?.descriptionOfLand?.properties?.[0]?.requiredAreaFAR || 0,

      // Ownership/Lease Details
      plotSubdivided: edcrData?.plotSubdivided,
      needCompounding: edcrData?.needCompounding,
      plotLeaseHold: edcrData?.plotLeaseHold,
      leaseholdNOC: edcrData?.leaseholdNOC,
      isMetroCity: edcrData?.isMetroCity,
      shelterFee: edcrData?.shelterFee,
      constructionType: edcrData?.constructionType,

      // Applicant Info
      applicantName: edcrData?.landInfo?.owners?.[0]?.name,
      aplicantMobileNumber: edcrData?.landInfo?.owners?.[0]?.mobileNumber,
      applicantEmailId: edcrData?.landInfo?.owners?.[0]?.emailId,

      // Licensee Info
      licenseeName: edcrData?.licenseeName,
      licenseeLicenceNumber: edcrData?.licenseeLicenceNumber || "",
      licenseeMobileNumber: edcrData?.licenseeMobileNumber || "",
      licenseeEmailId: edcrData?.licenseeEmailId || "",
      licenseeAddress: edcrData?.licenseeAddress || "",

      // System/Document Info
      file: edcrData?.file,
      signatureId: edcrData?.documents?.filter((doc) => doc.documentType === "signature")[0]?.fileStoreId || null,
      selectedOffice: edcrData?.additionalDetails?.selectedOffice,
      department: applicationFlow || null,
    };
    return { applicationData, isAppDataLoading };
  } else {
    const applicationData = {
      natureOfConstruction: null,
      landMark: null,
      planOn: null,
      isRevised: null,
      tehsil: null,
      schemeName: null,
      sectorNoPlotNo: null,
      fars: null,
      backSide: null,
      groundCoverages: null,
      setbackRears: null,
      setbackFronts: null,
      revenueVillage: null,
      subDevelopmentArea: null,
      developmentArea: null,
      isPlotSetback: null,
      isApprovedLayout: null,
      isSpecialProject: null,
      projectType: null,
      proposalType: null,
      sanctionNumber: null,
      sanctionDate: null,
      file: null,
      areaType: null,
      transactionNumber: uuidv4(),
      appliactionType: "BUILDING_PLAN_SCRUTINY",
      applicationSubType: "NEW_CONSTRUCTION",
      city: null,
      code: null,
      locality: null,
      doorNo: null,
      village: null,
      areaType: null,
      department: applicationFlow || null,
    };

    return { applicationData, isAppDataLoading: false };
  }
};

export default getGroupHousingData;
